import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import FlipMove from 'react-flip-move';
import { Waypoint } from 'react-waypoint';
import {
    authSelector,
    userSelector,
    awardSelector,
    awardCategorySelector,
    chapterSelector,
    rankSelector,
    awardRecipientSelector
} from '../redux/selectors'
import { toArray } from "../common/util";
import { hasPermission } from "../common/permissions";
import { fetchAwardItem, fetchAwardRecipients, postAwardRecipient } from '../redux/actions';
import Username from '../common/Username';
import AwardAssignForm from './AwardAssignForm';

class AwardDetail extends Component {

    constructor(props) {
        super(props);
        this.handleUpdate= this.handleUpdate.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        document.title = "Addiction | Guild Management | Awards | " + this.props.match.params.id;
        this.props.getAwardItem(this.props.match.params.id)
        this.props.getAwardRecipients(this.props.match.params.id)
    }

    handleUpdate() {
        if (!this.props.awardRecipients.pending && this.props.awardRecipients.more) {
            this.props.getAwardRecipients(this.props.match.params.id, this.props.awardRecipients.page);
        }
    }

    handleSubmit(values) {
        let newValues = {
            ...values,
            member: values.member
        };

        this.props.submitAwardRecipient(this.props.match.params.id, newValues)
    }


    render() {
        if (hasPermission('awards.change_award', this.props.auth.permissions) || hasPermission('awards.add_awardrecipient', this.props.auth.permissions)) {
            if (toArray(this.props.awards).filter((award) => award.slug === this.props.match.params.id).length) {
                const awardRecipients = toArray(this.props.awardRecipients.data)
                    .filter((recipient) => recipient.award === toArray(this.props.awards).filter((awards) => awards.slug === this.props.match.params.id)[0].id)
                    .sort((a, b) => b.id - a.id)
                    .map((recipient) => (
                    <div className="panel-adt" key={`${recipient.id}-recipient`}>
                        <div className="media-left">
                            <Username user={this.props.users[recipient.recipientDetail]} rank={this.props.ranks[this.props.users[recipient.recipientDetail].rank]} />
                        </div>
                        <div className="media-body">
                            {recipient.reason}
                        </div>
                    </div>
                ));
                return (
                    <div>
                        {toArray(this.props.awards)
                            .filter((awards) => awards.slug === this.props.match.params.id)
                            .map(award => (
                                <div>
                                    <h1>{award.title}</h1>
                                    <div className="panel-adt">
                                        <div className="media-left">
                                            <img alt={award.title} className="media-object" src={award.image.image} />
                                        </div>
                                        <div className="media-body">
                                            <div>{award.description}</div>
                                        </div>
                                    </div>
                                    <div className="panel-adt">
                                        <AwardAssignForm onSubmit={this.handleSubmit} award={award} users={this.props.users} />
                                    </div>
                                    <FlipMove
                                        staggerDelayBy={50}
                                        appearAnimation="fade"
                                        enterAnimation="fade"
                                        leaveAnimation="fade"
                                        className="news"
                                    >
                                        {awardRecipients}
                                    </FlipMove>
                                    <div>
                                        <Waypoint
                                            key="waypoint"
                                            onEnter={this.handleUpdate}
                                            bottomOffset='-10%'
                                        />
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                )
            } else { return null }
        } else {
            return <Redirect to="/" />
        }
    }
}


const mapStateToProps = (state) => ({
    auth: authSelector(state),
    users: userSelector(state),
    ranks: rankSelector(state),
    chapters: chapterSelector(state),
    awardCategories: awardCategorySelector(state),
    awardRecipients: awardRecipientSelector(state),
    awards: awardSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
    getAwardItem: (award) => dispatch(fetchAwardItem(award)),
    getAwardRecipients: (award, page) => dispatch(fetchAwardRecipients(award, page)),
    submitAwardRecipient: (award, values) => dispatch(postAwardRecipient(award, values)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AwardDetail);


// WEBPACK FOOTER //
// ./src/Officer/AwardDetail.js